import {ISubBrandItem} from '../../../services/hookService/products/useGetListSubBrand/types';
import {AdjectivalUnitTitle} from '../../../utilities/helper/unitGenerator/unit.types';
import {getInputGroupIconById} from '../../../utilities/helper/inputGroupIcon/getInputGroupIcon';

interface IProps {
  item: ISubBrandItem;
  inputGroupCode: number;
}
const ProductItemCard = ({item, inputGroupCode}: IProps) => {
  const imageUrl =
    item.image ??
    item.image_128 ??
    getInputGroupIconById({selectedInputGroup: inputGroupCode});
  return (
    <div className="flex flex-col gap-1 items-center p-3 w-full rounded-xl border border-gray-100 shadow-sm min-h-52">
      <img
        src={imageUrl}
        alt="product_image"
        className="object-cover w-12 h-12 rounded-full"
      />
      <span className="font-medium text-md">{item.sub_brand_name}</span>

      {item.quantity_pack && (
        <span className="text-sm text-gray-800">
          بسته {item.quantity_pack}{' '}
          {AdjectivalUnitTitle[item?.quantity_pack_unit ?? 'unitless']}
        </span>
      )}

      {item.brand_name && (
        <span className="text-sm text-gray-800">برند {item.brand_name}</span>
      )}

      {item.min_price && (
        <span className="font-medium text-md text-gray-950">
          از {item.min_price.toLocaleString()} تومان
        </span>
      )}

      <div className="flex gap-1 items-center mt-auto text-farm-shop-500 text-md">
        <span>مشاهده</span>
        <i className="icon-nameArrow---Left" />
      </div>
    </div>
  );
};
export default ProductItemCard;
